import React from "react";
import { motion } from "framer-motion";

export default function LoadingPage({
  children,
  animateLoad = "0%",
  isVisible,
}) {
  return (
    <motion.div
      initial={{ y: 0 }}
      animate={{ y: animateLoad }}
      transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      style={{
        width: "100%",
        height: "100vh",
        backgroundColor: "#000",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 50000,
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents: isVisible ? "auto" : "none",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{
          opacity: isVisible && animateLoad === "0%" ? 1 : 0,
          scale: isVisible && animateLoad === "0%" ? 1 : 1.1,
        }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <h3
          style={{
            fontSize: "clamp(22px, 5vw, 60px)",
            fontWeight: "200",
            letterSpacing: "8px",
            textTransform: "uppercase",
            margin: 0,
          }}
        >
          {children}
        </h3>
      </motion.div>
    </motion.div>
  );
}
